"use client"
import "./Tabs.css"

function Tabs({ tabs, activeTab, onChange, children }) {
  return (
    <div className="tabs">
      <div className="tabs-list">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tabs-trigger ${activeTab === tab.id ? "tabs-trigger-active" : ""}`}
            onClick={() => onChange(tab.id)}
            data-state={activeTab === tab.id ? "active" : "inactive"}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tabs-content">{children}</div>
    </div>
  )
}

export default Tabs

